import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

export const Container = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontFredoka};

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 16px;
  }
`;

export const Title = styled.div`
  margin-block-end: 16px;
`;

export const Contact = styled.div`
  margin-block-end: 16px;

  span {
    display: block;

    font-weight: 600;
  }
`;
export const Telephone = styled.div`
  span {
    font-weight: 600;
  }
`;
